import { render, staticRenderFns } from "./UsciteDetails.vue?vue&type=template&id=80b10c20&scoped=true"
import script from "./UsciteDetails.vue?vue&type=script&lang=js"
export * from "./UsciteDetails.vue?vue&type=script&lang=js"
import style0 from "./UsciteDetails.vue?vue&type=style&index=0&id=80b10c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b10c20",
  null
  
)

export default component.exports